export enum SettingsFieldName {
  accessTokenExpiration = 'accessTokenExpiration',
  watermarkTemplate = 'watermarkTemplate',
  watermarkOpacity = 'watermarkOpacity',
  watermarkRotation = 'watermarkRotation',
  watermarkRepeatPeriod = 'watermarkRepeatPeriod',
  watermarkFontSize = 'watermarkFontSize',
  watermarkColor = 'watermarkColor',
}

export interface SettingsFormValues {
  accessTokenExpiration: number | void;
  watermarkTemplate: string;
  watermarkOpacity: number;
  watermarkRotation: number;
  watermarkRepeatPeriod: number;
  watermarkFontSize: number;
  watermarkColor: string;
}

export type UpdateSettingsValues = SettingsFormValues;
